<div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header text-center">
          <h4>REPORTE DE COBRANZAS</h4>
          <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarCobranzas()"
          class="form-horizontal form-material noprint "
          id="categoryform"
          novalidate
        >
          <button class="noprint" onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>
          <div class="row">
            <div class="col-md-6">
              <label for="inputGroupSelect02">Vendedor</label>
              <select
                class="custom-select"
                id="inputGroupSelect02"
                formControlName="user_id"
              >
                <option value="">Todos</option>
                <option *ngFor="let vendedor of users" [ngValue]="vendedor.id">
                  {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                >
              </select>
            </div>
            <div class="col-md-6">
              

              <ng-select
              bindLabel="name"
              placeholder="Selecionar cliente"
              [searchable]="true"
              formControlName="cliente_id"
            >
            <ng-option value="">Todos</ng-option>

              <ng-option
                [value]="item"
                *ngFor="let item of clientes"
              >
                {{ item.nombres }} {{ item.apellidos }}
              </ng-option>
            </ng-select>
            </div>
          
          </div>
          <div class="form-row noprint">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['inicio']"
                [controlName]="'Fecha Inicio'"
              >
                <label for="inicio">Fecha Inicio</label>
                <input
                  class="form-control"
                  type="date"
                  id="inicio"
                  formControlName="inicio"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['fin']"
                [controlName]="'Fecha final'"
              >
                <label for="fin">Fecha fin</label>
                <input
                  class="form-control"
                  type="date"
                  id="fin"
                  formControlName="fin"
                />
              </app-form-error-wrapper>
              <!--              <input type="date" class="form-control" [ngModel]="final">-->
            </div>

            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
            <!--              <button type="submit" class="btn btn-primary" (click)="ListarExistencia()">Buscar</button>-->
          </div>
        </form>
        </div>
        <div class="card-body">
          <table
            class="table table-bordered table-striped table-condensed  table-responsive-md"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Pedido</th>
                <th>fecha Entrega</th>
                <th>Cliente</th>
                <th>Vendedor</th>
                <th>Tipo de Pago</th>
                <th>Total Venta</th>
                <th>Pagado</th>

                <th>Deuda</th>

              </tr>
            </thead>
            <tbody *ngFor="let data of ventas; let i = index">
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>
                  {{ data.orden_id}}
                </td>
                <td>
                  {{ data.fecha_entrega|date:"dd/MM/yyyy" }}
                </td>
                <td>
                  {{ data.cliente.nombres }}  {{ data.cliente.apellidos }}
                </td>
                <td>
                  {{ data.vendedor.nombres }}  {{ data.vendedor.apellidos }}
                </td>
              
                <td>{{ data.tipo_pago }}</td>
                <td>{{ data.total }}</td>
                <td>{{ data.pagado }}</td>

                <td>{{ data.deuda }}</td>

              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5"></td>
                <td colspan="1">SUBTOTAL</td>
                <td class="text-left">
                  {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
                </td>
                <td class="text-left">
                  {{ totalPagado | currency: 'BOB':'symbol-narrow':'1.2-2' }}
                </td>
                <td class="text-left">
                  {{ totalDeuda | currency: 'BOB':'symbol-narrow':'1.2-2' }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
  